// extracted by mini-css-extract-plugin
module.exports = {"container":"J_x","eyebrow":"J_H","title":"J_S","summary":"J_by","dark":"J_b","light":"J_c"};